/**
 * The LokerDollar symbol: an L and a D sharing one stroke (the D's base runs
 * on as the L's foot) on a rounded tile. Same geometry as `public/mark.svg`
 * and `public/favicon.svg`; inlined so the navbar costs no extra request and
 * follows the theme tokens (tile = primary, mark = primary-foreground).
 *
 * Decorative: the link that holds it always carries the "LokerDollar" label
 * (visible from `sm` up, screen-reader-only below), so it is aria-hidden.
 */
const BRAND_MARK_PATH =
	"M36 36H112A72 72 0 0 1 184 108V176H220V220H36Z M80 78H112A30 30 0 0 1 142 108V176H80Z";

export function BrandMark({ className = "size-7" }: { className?: string }) {
	return (
		<svg
			viewBox="0 0 256 256"
			aria-hidden="true"
			focusable="false"
			className={`shrink-0 ${className}`}
		>
			<rect width="256" height="256" rx="56" className="fill-primary" />
			<path
				d={BRAND_MARK_PATH}
				fillRule="evenodd"
				transform="translate(35.8 33.8) scale(0.72)"
				className="fill-primary-foreground"
			/>
		</svg>
	);
}
